import React, { useEffect, useState, useRef, useMemo, useImperativeHandle, useCallback, forwardRef } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  IconButton,
  Collapse,
  Box,
  TableCell,
  TableRow,
  styled,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Tabs,
  Tab,
} from '@mui/material';
import { useSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import ChevronUpIcon from '@mui/icons-material/ExpandLess';
import ChevronDownIcon from '@mui/icons-material/ExpandMore';
// import NewBaseLineOrderWorkunits from './NewBaseLineOrderWorkunits';
import CatalogWorkunitDataGrid from './OrderBaselineWorkunitsDataGrids/CatalogWorkunitDataGrid/CatalogWorkunitDataGrid';
// import useOrderWorkunitApi from 'features/Orders/OrderWorkunits/services/useOrderWorkunitApi';
import useBaseLineOrderWorkunitApi from '../services/useBaseLineOrderWorkunitApi';
import useOrderWorkunitsService from 'features/Orders/OrderWorkunits/services/useOrderWorkunitsService';
import SelectedWorkunitsDataGrid from './OrderBaselineWorkunitsDataGrids/SelectedWorkunitDatagrid/SelectedWorkunitsDataGrid';
// import InitialWorkunitsDataGrid from './OrderBaselineWorkunitsDataGrids/SelectedWorkunitDatagrid/InitialWorkunitsDataGrid';
import SummaryDataGrid from './OrderBaselineWorkunitsDataGrids/SummaryDataGrid/SummaryDataGrid';
import OrderApiService from 'api/OrderApiService';
import { getPurchaseOrderAction } from 'store/actions/purchaseOrderActions';
// import PurchaseOrders from 'types/entities/PurchaseOrders';
import { useAppState } from 'store/Provider';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import Order from 'types/entities/Order';
import {
  injectBLSelectedWorkunitsFilterAction,
  injectScopesAction,
  injectSelectedWorkunitsAction,
} from 'store/actions/catalogToOrderActions';
import { ChildRefbaseType } from '../../ChangeBaseline';
// import FilterTags from 'components/FilterTag/FilterTag';
import WorkunitFilterSystem from './OrderBaselineWorkunitsDataGrids/SummaryDataGrid/WorkunitFilterSystem';
import { setSnackbarAction } from 'store/actions/snackbarActions';

type NewBaselineProps = {
  currentStep: number;
  handleNext: React.Dispatch<React.SetStateAction<any>>;
  handleCancel: React.Dispatch<React.SetStateAction<any>>;
  setActiveBaseFlag: React.Dispatch<React.SetStateAction<any>>;
  setCurrentStep: React.Dispatch<React.SetStateAction<any>>;
  setIsCreating: React.Dispatch<React.SetStateAction<any>>;
};

const NewBaseline = forwardRef<ChildRefbaseType, NewBaselineProps>((props, ref) => {
  // const NewBaseline = forwardRef<NewBaselineRefType, NewBaselineProps>((props, ref) => {
  // const sourceOrder = useSelector((state) => state?.changeBaseline?.sourceOrder);
  const { currentStep, handleNext, handleCancel, setActiveBaseFlag, setCurrentStep, setIsCreating } = props;
  const { sourceOrder, baseLineOrder } = useSelector((state) => state.changeBaseline);
  const state = useSelector((state) => state.catalogToOrder);

  // State for active tab
  const [activeTab, setActiveTab] = useState(0);
  const catalog_id = sourceOrder?.catalog_id;
  const { dispatch } = useAppState();
  // const selectedScope: number = useSelector(
  //   (state) => (state.catalogToOrder.orderHandler.searchParams?.scope as number) ?? 0
  // );
  // const selectedWorkunitsList = useSelector((state) => state.catalogToOrder);

  const selectedWorkunitsFilter = useSelector((state) => state.catalogToOrder.selectedWorkunitsFilter);
  const selectedWorkunits = useSelector((state) => state.catalogToOrder.selectedWorkunits);
  // const combinedWorkunits = [...initialWorkunits, ...selectedWorkunits];

  const { fetchBaselineWorkunitsInCatalog, getBLOrderNewWorkunits, bulkCreateBaseLineOrderWorkunits } =
    useBaseLineOrderWorkunitApi();
  // const { getIntialBLOrderWorkunits } = useOrderWorkunitApi();
  const { getUniqScopesInOrder, updateSearchFilters, updateSelectedWorkunitsMonthChanged } = useOrderWorkunitsService();
  const [t] = useTranslation();
  const scopesInOrder = useMemo(() => getUniqScopesInOrder(), [getUniqScopesInOrder]);
  // State for collapsible sections
  const [catalogOpen, setCatalogOpen] = useState(true);
  const [newWorkunitsOpen, setNewWorkunitsOpen] = useState(true);
  const [initialWorkunitsOpen, setInitialWorkunitsOpen] = useState(false);
  const [summaryOpen, setSummaryOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedScopeFilter, setSelectedScopeFilter] = useState(0);

  // Refs for scrolling to sections
  const catalogRef = useRef(null);
  const newWorkunitsRef = useRef(null);
  // const initialWorkunitsRef = useRef(null);
  const summaryRef = useRef(null);

  const getPoScopeByBaseline = async (currentOrder: any) => {
    const { purchase_orders, order_scopes } = await OrderApiService.fetchPoScopeBaseline(
      Number(baseLineOrder?.id),
      2,
      currentOrder?.affair?.otp
    );

    dispatch(injectScopesAction(order_scopes?.datas));
    dispatch(getPurchaseOrderAction(purchase_orders));
  };

  useEffect(() => {
    if (!sourceOrder) return;

    const loadWorkunitsInCatalog = async () => {
      setIsLoading(true);
      setIsCreating(true);
      try {
        await fetchBaselineWorkunitsInCatalog(Number(catalog_id));
        await getPoScopeByBaseline(sourceOrder);
        // getUniqScopesInOrder();
        // getScopesByOrder(Number(order?.id));
        setIsLoading(false);
        setIsCreating(false);
        console.log('Workunits fetched successfully!');
      } catch (error) {
        console.error('Failed to fetch workunits:', error);
        setIsLoading(false);
        setIsCreating(false);
        // Handle error state, e.g., set an error message in state
      }
    };
    if (currentStep === 2) {
      const baselineVersion =
        sourceOrder?.baseline_version === 0 || sourceOrder?.baseline_version === null
          ? 1
          : Number(sourceOrder?.baseline_version) + 1;
      loadWorkunitsInCatalog();
      getBLOrderNewWorkunits(Number(baseLineOrder?.id), currentStep, Number(sourceOrder?.id), baselineVersion);
    }
  }, [currentStep]);

  // useEffect(() => {
  //   getBLOrderNewWorkunits(Number(baseLineOrder?.id), currentStep);
  // }, []);

  // useEffect(() => {
  //   if (state.selectedWorkunits.length === 0 && state.months.length === 0) return;
  //   updateSelectedWorkunitsMonthChanged(state.months);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [state.months.length, state.selectedWorkunits.length]);

  // useEffect(() => {
  //   if (state.months.length === 0) return;
  //   // getOrderWorkunits(Number(sourceOrder?.id));
  //   if (currentStep === 2) getBLOrderNewWorkunits(Number(baseLineOrder?.id), currentStep, Number(sourceOrder?.id));
  //   // getIntialBLOrderWorkunits(Number(sourceOrder?.id));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentStep]);

  // Tabs content
  const tabs = [
    {
      label: 'Add Workunit',
      state: catalogOpen,
      setState: setCatalogOpen,
      ref: catalogRef,
      count: state?.workunits?.length,
    },
    {
      label: 'Workunits',
      state: newWorkunitsOpen,
      setState: setNewWorkunitsOpen,
      ref: newWorkunitsRef,
      count: state?.selectedWorkunits?.length,
    },
    // {
    //   label: 'Initial Workunits',
    //   state: initialWorkunitsOpen,
    //   setState: setInitialWorkunitsOpen,
    //   ref: initialWorkunitsRef,
    //   count: state?.initialWorkunits?.length,
    // },
    { label: 'Summary', state: summaryOpen, setState: setSummaryOpen, ref: summaryRef, count: 0 },
  ];

  // Handle tab change
  const handleTabChange = (index: number) => {
    setActiveTab(index);

    // Open the selected tab's container
    tabs[index].setState(true);

    // Scroll to the section
    if (tabs[index].ref.current) {
      tabs[index].ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Toggle container collapse state
  const toggleContainer = (index: number) => {
    handleTabChange(index);
    tabs[index].setState(!tabs[index].state);
  };

  // Expose the function via useImperativeHandle
  useImperativeHandle(ref, () => ({
    handleSubmitNewbaseLine, // Assign the function here
    // You can expose other functions/values here too
  }));

  const handleSubmitNewbaseLine = async (fnName: string) => {
    setIsCreating(true);
    const baseVersion =
      sourceOrder?.baseline_version === 0 || sourceOrder?.baseline_version === null
        ? 1
        : Number(sourceOrder?.baseline_version) + 1;

    try {
      const res = await bulkCreateBaseLineOrderWorkunits(
        Number(sourceOrder?.id),
        Number(baseLineOrder?.id),
        baseVersion
      );
      if (res?.data) {
        if (fnName === 'save') {
          localStorage.setItem('activeBaseFlag', JSON.stringify('AffectationPage'));
          setActiveBaseFlag('AffectationPage');
          dispatch(setSnackbarAction({ message: 'Saved', open: true, severity: 'success', duration: 500 }));
          dispatch(injectSelectedWorkunitsAction([]));
          handleNext();
          setIsCreating(false);
        } else if (fnName === 'saveAaDraft') {
          setIsCreating(false);
          dispatch(injectSelectedWorkunitsAction([]));
          handleCancel();
        } else if (fnName === 'worunitadd') {
          dispatch(setSnackbarAction({ message: 'Saved', open: true, severity: 'success', duration: 500 }));
          setIsCreating(false);
        }
      } else {
        dispatch(
          setSnackbarAction({
            message: 'Error creating baseline workunits',
            open: true,
            severity: 'error',
            duration: 500,
          })
        );
        setIsCreating(false);
      }
    } catch (error) {
      setIsCreating(false);
      dispatch(setSnackbarAction({ message: 'Error saving baseline', open: true, severity: 'error', duration: 500 }));
    }
  };
  const handleWorkunitFilterChange = (event: SelectChangeEvent<number>) => {
    updateSearchFilters({ scope: event.target.value ?? 0 }, 'selected');
  };
  const handleScopeFilterChange = (event: SelectChangeEvent<number>) => {
    const updated = selectedWorkunits.filter(
      (item) => event.target.value === 0 || item.scope_id === event.target.value
    );
    setSelectedScopeFilter(Number(event.target.value));
    dispatch(injectBLSelectedWorkunitsFilterAction(updated));
    updateSearchFilters({ scope: event.target.value ?? 0 }, 'selected');
  };

  return (
    <Box sx={{ mb: 5 }}>
      <div className="bg-gray-100 p-4 w-full">
        {/* Quick Access Tabs */}
        {/* {order && <NewBaseLineOrderWorkunits order={order} />} */}

        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
            Loading order data...
          </Box>
        ) : (
          <>
            <Card sx={{ mb: 4, borderRadius: 2 }}>
              <CardContent sx={{ pb: 0, mb: 0 }}>
                <Grid
                  container
                  spacing={12} // Adjusted spacing for better visual
                  alignItems="center"
                  sx={{ flexWrap: { lg: 'nowrap' }, px: 2 }} // Added padding to match image
                >
                  <Grid item xs={12} lg="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                    <PlayArrowIcon sx={{ mr: 0.5, color: 'success.main' }} /> {/* Icon for Quick Access */}
                    <Typography variant="body1" component="div" color="textPrimary" sx={{ fontWeight: 600 }}>
                      Quick Access:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg sx={{ flexGrow: 1 }}>
                    {' '}
                    <Tabs
                      onChange={(event, newValue) => handleTabChange(newValue)}
                      aria-label="quick access tabs"
                      role="tablist"
                      value={activeTab}
                    >
                      {tabs.map((tab, index) => (
                        <Tab
                          key={`tab-${tab.label}`}
                          label={
                            <Typography variant="body1" component="div" color="textPrimary" sx={{ fontWeight: 600 }}>
                              {tab.label}
                            </Typography>
                          }
                          value={index}
                          sx={{
                            // '&:not(:first-of-type)': {
                            //   borderLeft: '1px solid #e0e0e0', // vertical line between tabs
                            // },
                            // borderRight: index < tabs.length - 1 ? '1px solid #e0e0e0' : 'none',
                            textTransform: 'none', // Prevent uppercase
                            minWidth: 0, // Allow tabs to shrink
                            px: 12, // Custom horizontal padding
                            py: 1, // Custom vertical padding
                            borderRadius: 0, // Slight border radius for each tab
                            '&:not(.Mui-selected)': {
                              color: 'text.primary', // Default text color for unselected tabs
                            },
                            // Add a right margin to create the visual separation/divider
                            mr: 8, // Add margin to all but the last tab
                          }}
                        />
                      ))}
                    </Tabs>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Collapsible Sections */}
            {tabs.map((tab, index) => (
              <div key={`section-${tab.label}`} ref={tab.ref} style={{ borderRadius: 1, overflow: 'hidden' }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    px: 2,
                    py: 1.5,
                    bgcolor: 'grey.50',
                    borderBottom: tab.state ? '1px solid grey.200' : 'none',
                  }}
                >
                  <Typography variant="h4" color="neutral.main" sx={{ mr: 1 }}>
                    {tab.label}
                  </Typography>
                  <IconButton
                    onClick={() => toggleContainer(index)}
                    aria-label={tab.state ? 'Minimize' : 'Expand'}
                    size="small"
                    sx={{
                      borderRadius: 1,
                      '&:hover': { bgcolor: 'grey.200' },
                    }}
                  >
                    {tab.state ? <ChevronUpIcon /> : <ChevronDownIcon />}
                  </IconButton>
                </Box>

                <Collapse in={tab.state}>
                  <Box sx={{ p: 2, overflowX: 'auto' }}>
                    {catalogOpen && index === 0 && <CatalogWorkunitDataGrid />}
                    {newWorkunitsOpen && index === 1 && (
                      <>
                        <Box
                          sx={{
                            display: 'flex',
                            // alignItems: 'center',
                            gap: 2, // spacing between select and tags
                            mb: 2,
                            maxWidth: '100%', // optionally limit width to container
                            flexWrap: 'wrap', // wrap on small screens
                          }}
                        >
                          <Box sx={{ minWidth: 150 }}>
                            <FormControl fullWidth>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                variant="filled"
                                onChange={handleScopeFilterChange}
                                value={selectedScopeFilter}
                                size="small"
                              >
                                <MenuItem value={0}>{t('All_project')}</MenuItem>
                                {state?.scopes?.length &&
                                  state?.scopes?.map((scopeInOrder) => (
                                    <MenuItem key={scopeInOrder?.id} value={scopeInOrder?.id}>
                                      {scopeInOrder?.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>
                          </Box>
                          {selectedWorkunits && <WorkunitFilterSystem selectedScopeFilter={selectedScopeFilter} />}
                        </Box>

                        <SelectedWorkunitsDataGrid
                          selectedWorkunitsFilter={selectedWorkunitsFilter}
                          setCurrentStep={setCurrentStep}
                          handleSubmitNewbaseLine={handleSubmitNewbaseLine}
                        />
                      </>
                    )}
                    {/* {initialWorkunitsOpen && index === 2 && <InitialWorkunitsDataGrid />} */}
                  </Box>
                  {summaryOpen && index === 2 && <SummaryDataGrid />}
                </Collapse>
              </div>
            ))}
          </>
        )}
      </div>
    </Box>
  );
});

export default NewBaseline;
